import { render, staticRenderFns } from "./ShiJi.vue?vue&type=template&id=4b13f27b&scoped=true&"
import script from "./ShiJi.vue?vue&type=script&lang=js&"
export * from "./ShiJi.vue?vue&type=script&lang=js&"
import style0 from "./ShiJi.vue?vue&type=style&index=0&id=4b13f27b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b13f27b",
  null
  
)

export default component.exports